export enum SingleDatePickerPlaceholders {
  dateLabel = "Select date",
}
